// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DealerRecommendationResult from './dealer-recommendation-result';
import {FormattedMessage} from 'react-intl';
import ListViewShowMore from './list-view-show-more';

const DealerRecommendationsList = props => {

    let list;

    if (props.dealerRecommendations.length) {

        const dealerRecommendationEl = props.dealerRecommendations.map(dealerRecommendation =>
            <DealerRecommendationResult
                dealerRecommendation={dealerRecommendation}
                handleDealerChange={event => props.handleDealerChange(event, dealerRecommendation)}
                initialState={props.selectedDealerRecommendations}
                key={dealerRecommendation.id}
                openDealerRecommendationModal={(message, title, type) => props.openDealerRecommendationModal(message, title, type, dealerRecommendation)}
                uid='id'
            />
        );

        list = (
            <ListViewShowMore
                handleMore={props.handleMore}
                totalItems={props.totalElements}
                totalPages={props.totalPages}
            >
                {dealerRecommendationEl}
            </ListViewShowMore>
        );

    } else {

        list = props.isSearchResultEmpty ?
            <span className='empty'><FormattedMessage id='FILTER_DEALER_RECOMMENDATIONS_MESSAGE'/></span> :
            <span className='empty'><FormattedMessage id='NO_RESULTS_FOUND'/></span>;

    }

    return (
        <div className='product-list'>
            <div className='list-header'>
                {props.children}
            </div>
            {list}
        </div>
    );

};

DealerRecommendationsList.displayName = 'DealerRecommendationsList';
DealerRecommendationsList.propTypes = {
    children: PropTypes.node,
    dealerRecommendations: PropTypes.instanceOf(Array).isRequired,
    handleMore: PropTypes.func.isRequired,
    isSearchResultEmpty: PropTypes.bool,
    selectedDealerRecommendations: PropTypes.instanceOf(Array).isRequired,
    totalElements: PropTypes.number.isRequired,
    totalElementsCount: PropTypes.number,
    totalPages: PropTypes.number
};

export default DealerRecommendationsList;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation-list.js